const initialWebSocketState = {
    message: ""
}
const NotificationBucket = (state = initialWebSocketState, action) => {
    switch(action.type){
        case "ADD_NOTIFICATION":
            return {
                ...state,
                message: action.payload
            }
        default:
            return state
    }
}

export default NotificationBucket;